import React, { useState } from 'react'
import { Field } from 'redux-form/immutable'
import cn from 'classnames'

import { PROMO_PAGE_SETTINGS, GALLERY_S3_ENTITY } from 'app/constants/gallery'

import CameraIcon from 'app/components/SVGS/Camera'
import Gallery from 'app/domains/common/Gallery'

import { IEditImageBlockProps } from './interface'

import './styles.scss'

const bc = 'edit-image-block '

const EditImageBlock: React.FC<IEditImageBlockProps> = ({
  className,
  iconWrapperClass,
  imageInputProps,
  fieldWrapperClass,
  name,
  minImageWidth = 300,
  minImageHeight = 300,
  isPageEdit = false,
}) => {
  const [showInput, setShowInput] = useState(false)

  if (!isPageEdit) {
    return null
  }

  return (
    <>
      <div className={cn(bc, { [className as string]: className })} onClick={() => setShowInput(!showInput)}>
        <div className={iconWrapperClass}>
          <CameraIcon
            size={30}
            pathProps={{
              fill: '#087acb',
            }}
          />
        </div>
      </div>

      {showInput && (
        <div className={fieldWrapperClass}>
          <Field
            name={name}
            component={Gallery}
            imageInputProps={imageInputProps}
            minImageWidth={minImageWidth}
            minImageHeight={minImageHeight}
            innerModifier={PROMO_PAGE_SETTINGS}
            s3Entity={GALLERY_S3_ENTITY[PROMO_PAGE_SETTINGS]}
            isShowGalleryItems={false}
          />
        </div>
      )}
    </>
  )
}

export default EditImageBlock
